<template>
  <div id="interviewRoom"></div>
</template>

<script>
// 本地运行 this.$AgoraEdu.AgoraEduSDK
// 开发环境 AgoraEduSDK



import { domain } from '../../../../package.json'
import { AgoraEduSDK } from 'agora-classroom-sdk'
var timer = null;
// console.log('xxx',typeof window)
// const { domain } = require('package.json');
export default {
  $title: '在线教学3',
  $icon: 'el-icon-data-board',
  $route_path: 'interviewRoom/:room',
  name: 'interviewRoom',
  data() {
    return {
      form: {
        // 你的声网 token，生成token的uid需要和userUuid一致                                           
        rtmToken: "",
        userUuid: '', // 你的用户全局唯一标识
        userName: '111',  // 用户名称
        // this.$route.params.room
        roomUuid: this.$route.query.row.id, // 你的房间全局唯一标识，互通需要双方进入同一个房间
        roomName: `录制: ${this.$route.query.row.id}`,
        roleType:this.$route.query.type ? 1 : 0, //用户课堂角色
        roomType: 0, //课堂类型
        pretest: !!this.$route.query.type,   //开启课前设备检测 !!this.$route.query.type
        // !!this.$route.query.type
        language: "zh",
        startTime:'',
        duration: null,  // 课堂的持续时间，课堂会在指定时间自动结束
        courseWareList: [],
        personalCourseWareList:[],
        // ${domain}
        // https://nba.hupu.com/
        // ${domain}/admin/interviewRoom/${this.$route.params.room}?videoBitrate=8000
        recordUrl: `${domain}/#/admin/interviewRoom/${this.$route.query.row.id}?videoBitrate=8000`,  // 待录制 URL 地址
        listener: (evt,params) => {
          // console.log("监听8888888888888", evt,params,this.$route.query.type,!this.$route.query.type)
          if ( evt === 1 && Boolean(1)) {
             // 通知服务器端录制页面已完全加载。
            // window.setInterval(() => {
            //   setTimeout(fun, 0)
            // }, 5000)
              timer = setInterval(() =>{
                setTimeout(()=> {
                  this.$api.videoReady({ roomUuid: this.$route.query.row.id }).then(res => {
                            console.log('定时',res,res.data.data.statusCode === 200)
                          if( res.data.data.statusCode === 200 ) this.startVideo();
                  })
                }, 0)

              },5000);

          }
          if(evt === 2 && Boolean(1)) {
              clearInterval(timer);

            this.$api.videoStop({ cid : this.$route.query.row.id,sid: this.subject_id  }).then(() => {
              this.$store.commit('updateIsInterview', false);
              clearInterval(timer);
              this.$router.back();
            })
          }
          if(evt === 2 && !this.$route.query.type) {
            this.$store.commit('updateIsInterview', false);
            this.$router.back();
          }
        }
      },
      pagination: {
        page_size: 20,
        page_index: 1,
        total: 0,
        loading: false,
        prop: '',
        order: '',
        subject_id: '',
        keyword: '',
        roomId:this.$route.query.row.id
      },
      joined: false,
      records:{},
      durMin: 0,
      subject_id:'',
      wareList:[]
      // AgoraRTC:''
    }
  },
  mounted() {
    console.log(this.$route.query,'uuuuuu')
    this.records=this.$route.query.row
    this.$store.commit('updateIsInterview', true);
    // this.window = window;
    // const AgoraRTC = require('agora-classroom-sdk');
    console.log('interviewRoom123',timer,this.$route.params.room,this.$route.query,this.$route.query.type ? 1 : 0)
    if(this.$route.query.type) {
      this.getRecords();
    }else {
      this.form.userUuid = Math.round(Math.random()*100).toString();
      this.setupClassroom();
    }
  },
  destroyed() {
    this.$store.commit('updateIsInterview', false);

  },
  methods:{
    getRecords() {
        console.log(this.pagination.roomId,'roommmmmmmmmmmmmmmmmm')
      this.pagination.loading = true;
      // this.$api.courseList(this.pagination).then(({ data: res }) => {
        // console.log(res,'00000000000000000000')
        // this.records = res.data.list[0];
        this.form.userUuid= this.records.intervieweeId; // 你的用户全局唯一标识
        this.form.userName= this.records.intervieweeName;  // 用户名称
        this.form.roomName= this.records.interviewName;
        this.form.startTime = new Date(this.records.planStartTime).getTime();
        this.form.duration = (((new Date(this.records.planEndTime).getTime()) - (new Date(this.records.planStartTime).getTime())) / 1000) ;
        // this.durMin + 3600
        // this.subject_id = this.records.subject_id
        console.log('aaa11',this.form.roomUuid,this.records)
        let scenseList =[]
        this.$api.coursewareList({ cid: this.$route.query.row.id }).then(({ data: res }) => {
          console.log(res,'11111111111111111111111')
          if(res.data.list.length > 0) {
            scenseList = [];
            this.form.courseWareList = res.data.list.map(o => {
              o.resourceName = o.name;
              o.resourceUuid = o.fid;
              o.ext = o.name ? `${o.name.split('.').pop()}`: '';
              o.fileurl = o.url;
              // console.log('12211221',o.url,o.name,o.ext)
              o.url = ["ppt","pptx","doc","docx","pdf"].includes(`${o.ext}`) ? null : o.url;
              ["ppt","pptx","doc","docx","pdf"].includes(`${o.ext}`) ? o.scenes = [{
                name: `${o.name}`,
                ppt: {
                  name: `${o.name}`,
                  src: `${o.fileurl}`,
                  width: 480,
                  height: 360
                },
                pptx: {
                  name: `${o.name}`,
                  src: `${o.fileurl}`,
                  width: 480,
                  height: 360
                },
                doc: {
                  name: `${o.name}`,
                  src: `${o.fileurl}`,
                  width: 480,
                  height: 360
                },
                docx: {
                  name: `${o.name}`,
                  src: `${o.fileurl}`,
                  width: 480,
                  height: 360
                },
                pdf: {
                  name: `${o.name}`,
                  src: `${o.fileurl}`,
                  width: 480,
                  height: 360
                }
              }] : o.scenes = [];
              o.size = '';
              o.updateTime = '';
              o.taskUuid = "123";
              o.taskToken= "xxx";
              o.taskProgress= '';
              return o;
            })
          }
          this.setupClassroom();

        })
      // })
    },
    setupClassroom() {
        // this.startVideo();

      // console.log('class',AgoraRTC)
      
      if(!this.joined) {
        this.$api.agoraToken1({channel: this.$route.query.row.id,uid:this.form.userUuid,type:1 }).then(({ data: res }) => {
          console.log(res,'2222222222222222222')
          // this.form.appID = res.data.appID;
          this.form.rtmToken = res.data.rtmToken;
          console.log('this.form.appID:',this.$AgoraEdu,res.data.appID,this.form)
          AgoraEduSDK.config({
            appId: res.data.appID,
          })
          // this.startVideo();
          AgoraEduSDK.launch(document.querySelector("#interviewRoom"),this.form);
          // this.startVideo();
        })

        // setTimeout(() =>{
        //   this.startVideo();
        // },5000);
      }

    },
    startVideo() {
      this.$api.videoStart(this.form).then(res => {
        // console.log('start',res)
        // if(res.data.data.statusCode  === 200) {clearInterval(timer);}
      })
    },

  },
    beforeRouteLeave(to,from,next) {
      clearInterval(timer);
      console.log(this.form)
      next()
    }
}
</script>

<style scoped lang="less">
::v-deep .fcr-hx-send-btn{
  bottom: 25px;
}
::v-deep .scenes-controller-container{
  bottom: 30px;
}

  #interviewRoom {
    position: absolute;
    width: 108%;
    overflow: hidden;
    //height: 100%;
    //background: green;
    //position: relative;
    //margin: -16px; /*no*/
    //padding: 16px; /*no*/
    //box-sizing: border-box;
    height: calc(100vh - 82px); /*no*/
    //background-color: #006ede;
    //background-image: url(/static/images/bg.min.png);
    //background-size: cover;
    //display: flex;
    //flex-direction: column;
    .btn{
      line-height: 0.5rem !important;
    }
  }
</style>
<style lang="less">

#interviewRoom {
  .fcr-btn {
    line-height: normal;
  }

  .layout-aside {
    max-width: 18rem;
    min-width: 0rem !important;
  }

  .edu-room {
    height: calc(100vh - 82px) !important;
  }
}
//.btn{
//  line-height: 0.5rem !important;
//}
//.chat-texting {
#interviewRoom .chat-texting {
  .btn {
    line-height: 0.5rem !important;
  }
}

</style>
